// extracted by mini-css-extract-plugin
export var image = "blogposts-module--image--1nLrm";
export var gatsbyWrapper = "blogposts-module--gatsbyWrapper--3dlIm";
export var highlight = "blogposts-module--highlight--3GaHy";
export var svg = "blogposts-module--svg--1myIu";
export var blogpreview = "blogposts-module--blogpreview--16DQh";